import { COLORS } from "../lib/colors";

export const ColorPicker = ({ selected, onSelect, dense = false }) => {
  return (
    <div
      data-testid="color-picker"
      className={`grid ${
        dense ? "grid-cols-10" : "grid-cols-5 sm:grid-cols-10"
      } gap-[1px] bg-[var(--kb-fg)]`}
    >
      {COLORS.map((c) => {
        const isActive = selected?.id === c.id;
        return (
          <button
            key={c.id}
            data-testid={`color-swatch-${c.id}`}
            onClick={() => onSelect(c)}
            className="kb-swatch group"
            aria-label={c.name}
          >
            <span
              className="absolute inset-0"
              style={{ background: c.hex }}
            />
            {isActive && (
              <span className="absolute inset-1 border-2 border-[var(--kb-fg)] mix-blend-difference" />
            )}
            <span className="absolute top-1 left-1 kb-mono-label text-[8px] mix-blend-difference text-white opacity-70">
              {String(c.index || COLORS.indexOf(c) + 1).padStart(2, "0")}
            </span>
            {!dense && (
              <span className="absolute inset-x-0 -bottom-5 kb-mono-label text-[9px] text-[var(--kb-fg-2)] opacity-0 group-hover:opacity-100 transition-opacity hidden sm:block">
                {c.name}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};
